import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import './loginpopup.css';
import api from '../../api/axios';
import ResetPasswordPopUp from "../reset-pw/reset-pw";
import { useTranslation } from 'react-i18next';

function LoginPopUp(props) {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [userData, setUserData] = useState({ email: '', passwort: '' });
    const [loginMessage, setLoginMessage] = useState('');
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [pictureSrc, setPictureSrc] = useState("");

    useEffect(() => {
        const fetchPicture = async () => {
            try {
                const pictureId = 12; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    });

    const handleGoogleLogin = () => {
        // Später Anmeldung über Google einfügen!
        console.log('Google login clicked');
    };

    const handleChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/user/login', userData);
            const userDataFromServer = response.data;

            const safeUserData = {
                userid: userDataFromServer.userid,
                email: userDataFromServer.email,
                // add more fields if you need them, but NOT profilbild
            };

            sessionStorage.setItem("token", response.data.token);
            sessionStorage.setItem("userData", JSON.stringify(response.data.user));
            if (window.location.pathname === '/profile') {
                // Force page reload if already on the /profile route
                window.location.reload();
            } else {
                navigate('/profile');
            }
            props.setTrigger(false);
        } catch (error) {
            console.error('Fehler beim User Anmelden', error);
            setLoginMessage('Diese Email und Passwort Kombination existiert nicht. Bitte versuche es erneut.');
        }
    };

    const handleForgotPasswordClick = () => {
        props.setTrigger(false);
        setShowResetPassword(true);
    };

    const handleSignUpClick = () => {
        props.setTrigger(false);
        props.setSignUpTrigger(true);
    };

    return (
        <>
            {props.trigger && (
                <div className="LoginPopUp-wrapper">
                    <div className="LoginPopUp-inner">
                        <button className="close-btn-login" onClick={() => props.setTrigger(false)}>&times;</button>
                        <div className="image-container" onClick={handleSignUpClick}>
                            {pictureSrc ? (
                                <img src={pictureSrc} alt="Traffic Cone" />
                            ) : (
                                <p>{t('LoadingLogo')}</p>
                            )}
                        </div>
                        <form id="form" onSubmit={handleSubmit}>
                            <div className="form-content">
                                {props.children}
                                <div id="welcome-txt">
                                    <h2>{t('WelcomeBack')}</h2>
                                    <p>{t('NiceToBeBack')}</p>
                                </div>
                                <label htmlFor="emailLogin">{t('EMailAddress')}</label>
                                <input
                                    className="input-field"
                                    type="email"
                                    id="emailLogin"
                                    name="email"
                                    placeholder="E-Mail eingeben..."
                                    onChange={handleChange}
                                    required
                                />
                                <label htmlFor="passwortLogin">{t('Password')}</label>
                                <input
                                    className="input-field"
                                    type="password"
                                    id="passwortLogin"
                                    name="passwort"
                                    placeholder="Passwort eingeben..."
                                    onChange={handleChange}
                                    required
                                />
                                <div className="forgot-password">
                                    <span onClick={handleForgotPasswordClick}>{t('ForgotPassword')}</span>
                                </div>
                                <button className="login-btn" type="submit">{t('SignIn')}</button>
                                <p className="login-message">{loginMessage}</p>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <ResetPasswordPopUp trigger={showResetPassword} setTrigger={setShowResetPassword} />
        </>
    );
}

export default LoginPopUp;